export default "__VITE_ASSET__3eb52877__"